import { Component, Input, OnInit } from '@angular/core'
import { ActionService } from '../../../../../action-module/services/action.service'
import { Dashlet } from '../../../../models/entity-configuration'
import { EntityReference } from '../../../../models/entity-reference'

@Component({
  selector: 'jml-lib-button-dashlet',
  templateUrl: './button-dashlet.component.html',
  styleUrls: ['./button-dashlet.component.scss']
})
export class ButtonDashletComponent implements OnInit {
  @Input() dashlet: Dashlet
  @Input() entityReference: EntityReference

  loading = false

  constructor(private actionService: ActionService) {}

  ngOnInit(): void {}

  performAction() {
    this.loading = true
    this.actionService.performAction(this.dashlet.actionHrid, this.entityReference, undefined, () => {
      this.loading = false
    })
  }
}
